<template>
  <div class="w-full flex flex-col gap-1.5">
    <div
      class="text-slate-600 text-base font-medium font-['Public Sans'] leading-relaxed"
    >
      Recurrence
    </div>
    <div
      :class="
        stacked ? 'w-full flex flex-col gap-3' : 'w-full flex gap-5 items-start'
      "
    >
      <select
        :value="recurrence"
        @change="$emit('update:recurrence', $event.target.value)"
        class="w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid"
      >
        <option value="">Does not repeat</option>
        <option value="daily">Daily</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
        <option value="yearly">Yearly</option>
      </select>

      <template v-if="recurrence">
        <div class="w-full flex items-center gap-2">
          <span class="text-slate-600 whitespace-nowrap">Every</span>
          <input
            type="number"
            min="1"
            :value="recurrenceInterval"
            @input="$emit('update:recurrenceInterval', $event.target.value)"
            class="w-24 px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid"
          />
          <span class="text-slate-600 whitespace-nowrap">{{ unitLabel }}</span>
        </div>

        <div class="w-full flex items-center gap-2">
          <span class="text-slate-600 whitespace-nowrap">Ends on</span>
          <input
            type="date"
            :value="recurrenceEnd"
            @input="$emit('update:recurrenceEnd', $event.target.value)"
            class="w-full px-3 py-2 bg-white rounded-lg shadow border-2 border-green-400 border-solid"
          />
        </div>
      </template>
    </div>
    <p v-if="recurrence" class="text-sm text-slate-500">
      When the due date (UTC) is reached and all tasks are Complete, the
      project is closed and a new empty copy with the same tasks and resources
      is created for the next cycle. No new cycles start after "Ends on"; leave
      it empty to repeat indefinitely.
    </p>
  </div>
</template>

<script>
import { computed } from "vue";

const UNIT_LABELS = {
  daily: "day(s)",
  weekly: "week(s)",
  monthly: "month(s)",
  yearly: "year(s)",
};

export default {
  props: {
    recurrence: { type: String, default: "" },
    recurrenceInterval: { type: [Number, String], default: 1 },
    recurrenceEnd: { type: String, default: "" },
    stacked: { type: Boolean, default: false },
  },
  emits: [
    "update:recurrence",
    "update:recurrenceInterval",
    "update:recurrenceEnd",
  ],
  setup(props) {
    const unitLabel = computed(() => UNIT_LABELS[props.recurrence] || "");
    return { unitLabel };
  },
};
</script>
